module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_copy-fc3268bba5954c8c6e54c7b118bb3c08.svg";